export const DEVICE = {
  FETCH_ALL: 'DEVICE.FETCH_ALL',
  RE_FETCH_ALL: 'DEVICE.RE_FETCH_ALL',
  FETCH_ALL_FAILED: 'DEVICE.FETCH_ALL_FAILED',
  SET_ALL: 'DEVICE.SET_ALL',
  
  FETCH: 'DEVICE.FETCH',
  FETCH_FAILED: 'DEVICE.FETCH_FAILED',
  
  FETCH_BY_USER_ID: 'DEVICE.FETCH_BY_USER_ID',
  RE_FETCH_BY_USER_ID: 'DEVICE.RE_FETCH_BY_USER_ID',
  FETCH_BY_USER_ID_FAILED: 'DEVICE.FETCH_BY_USER_ID_FAILED',
  SET: 'DEVICE.SET',
  
  REGISTER: 'DEVICE.REGISTER',
  SET_REGISTERED : 'DEVICE.SET_REGISTERED'
};

export const fetchAllDevices = () => ({
  type: DEVICE.FETCH_ALL
});

export const reFetchAllDevices = () => ({
  type: DEVICE.RE_FETCH_ALL
});

export const fetchDevicesByUserId = (userId) => ({
  type: DEVICE.FETCH_BY_USER_ID,
  payload: {data: userId}
});

export const reFetchDevicesByUserId = (userId) => ({
  type: DEVICE.RE_FETCH_BY_USER_ID,
  payload: {data: userId}
});

export const registerDevice = (data) => ({
  type: DEVICE.REGISTER,
  payload: {data: data}
});


// WEBPACK FOOTER //
// ./src/actions/device.js